import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';

export class FriendReferralTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'friendReferral';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'friendReferralPopupOpened') return false;

    await showTutorial('friendReferral', {
      $stepIndex: 7,
      $stepName: 'friend_referral_popup',
    });

    return true;
  }
}
